/* App.svelte generated by Svelte v3.24.0 */
import {
	SvelteComponent,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	transition_in,
	transition_out
} from "svelte/internal";

import { setContext, createEventDispatcher } from "svelte";
import { getClient } from "./client";
import { assignValueToTarget } from "./targets";
import PostcodeLookup from "./PostcodeLookup/index.svelte";

function create_fragment(ctx) {
	let div;
	let postcodelookup;
	let div_class_value;
	let current;
	postcodelookup = new PostcodeLookup({});
	postcodelookup.$on("address", /*handleAddress*/ ctx[1]);

	return {
		c() {
			div = element("div");
			create_component(postcodelookup.$$.fragment);
			attr(div, "class", div_class_value = /*root*/ ctx[0].container);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(postcodelookup, div, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(postcodelookup.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postcodelookup.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(postcodelookup);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { apiKey } = $$props;
	let { apiOverrides = {} } = $$props;
	let { style = {} } = $$props;

	let { addressTargets = {
		addressLine1: "[data-address-line1]",
		locality: "[data-address-locality]",
		county: "[data-address-county]",
		postcode: "[data-address-postcode]"
	} } = $$props;

	const dispatch = createEventDispatcher();
	setContext("style", style);
	setContext("client", () => getClient(apiKey, apiOverrides));
	const { classNames: { root = {} } = {} } = style;

	const handleAddress = ({ detail }) => {
		dispatch("address", detail);
		assignValueToTarget(addressTargets.addressLine1, detail.address);
		assignValueToTarget(addressTargets.locality, detail.locality);
		assignValueToTarget(addressTargets.county, detail.region);
		assignValueToTarget(addressTargets.postcode, detail.postcode);
	};

	$$self.$set = $$props => {
		if ("apiKey" in $$props) $$invalidate(2, apiKey = $$props.apiKey);
		if ("apiOverrides" in $$props) $$invalidate(3, apiOverrides = $$props.apiOverrides);
		if ("style" in $$props) $$invalidate(4, style = $$props.style);
		if ("addressTargets" in $$props) $$invalidate(5, addressTargets = $$props.addressTargets);
	};

	return [root, handleAddress, apiKey, apiOverrides, style, addressTargets];
}

class App extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			apiKey: 2,
			apiOverrides: 3,
			style: 4,
			addressTargets: 5
		});
	}
}

export default App;